import { render, staticRenderFns } from "./AddBankDetails.vue?vue&type=template&id=769a16ae&scoped=true"
import script from "./AddBankDetails.vue?vue&type=script&lang=js"
export * from "./AddBankDetails.vue?vue&type=script&lang=js"
import style0 from "./AddBankDetails.vue?vue&type=style&index=0&id=769a16ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a16ae",
  null
  
)

export default component.exports